import { Stack, Typography } from "@mui/material";
import React from "react";
import { EventFAQSvg } from "@onair/ui/svg/event-faq";

interface Props {
	showIcon?: boolean;
}

const FAQHeader = ({ showIcon = true }: Props) => {
	return (
		<Stack direction="row" spacing={2} alignItems="center">
			{showIcon && <EventFAQSvg />}
			<Typography variant="subtitle1" flex={1}>
				Câu hỏi thường gặp
			</Typography>
		</Stack>
	);
};

export default FAQHeader;
